const green400Color = '#2EC352';

export default green400Color;
